import { OPERATION } from "../spec";
import { SchemaDefinition } from "../annotations";
import { ChangeOperation, Ref } from "./ChangeTree";

export class ChangeSet {
    changes: { [index: number]: ChangeOperation } = {};
    changed: boolean = false;
    allChanges: Set<number> = new Set();
    // definition: SchemaDefinition;

    change(index: number, operation: OPERATION = OPERATION.ADD) {
        const previousChange = this.changes[index];

        if (
            !previousChange ||
            previousChange.op === OPERATION.DELETE ||
            previousChange.op === OPERATION.TOUCH // (mazmorra.io's BattleAction issue)
        ) {
            this.changes[index] = {
                op: (!previousChange)
                    ? operation
                    : (previousChange.op === OPERATION.DELETE)
                        ? OPERATION.DELETE_AND_ADD
                        : operation,
                index
            };
        }

        this.allChanges.add(index);

        this.changed = true;
    }

    discardAll() {
        this.changes = {};
    }

    setParent(...args: any[]) {
    }

}